{
  "header": "<h2>{{name}}, voici ce qui vous est offert pour l'achat de <payment />!</h2>",
  "header-expired": {
    "name": "<h2>{{name}}, besoin de plus de temps pour prendre une décision?</h2>",
    "no-name": "<h2>Besoin de plus de temps pour prendre une décision?</h2>"
  },
  "subheader": "Un acompte est exigible aujourd'hui, puis le solde restant est à payer par mensualités.",
  "subheader-zero-down": "0 $ à verser aujourd'hui! Ensuite, payez le solde total en versements mensuels.",
  "inputs-header": "Détails de facturation",
  "required-fields": "Tous les champs sont requis",
  "select-payment-method": "Sélectionnez un mode de paiement",
  "payment-option": {
    "debit": "Carte de débit",
    "bank-account": "Ajoutez votre compte bancaire",
    "bank-account-desc": "Pour plus de commodité et de fiabilité, connectez votre compte bancaire. Configurez-le et n'y pensez plus !",
    "credit": "Carte de crédit"
  },
  "payment-faq-button": "Quelles sont mes options de mode de paiement ?",
  "select-payment-method-error": "Vous devez sélectionner un mode de paiement",
  "plaid-locked-error": "Veuillez sélectionner un autre mode de paiement.",
  "plaid-link-token-error": "Oups! Une erreur s’est produite. Veuillez réessayer ou sélectionner un autre mode de paiement.",
  "recommended": "Recommandé",
  "offerSelector": {
    "srOnly": {
      "multipleOfferSelectedTitle": "Offre de paiement échelonné sélectionnée n° {{index}}",
      "multipleOfferTitle": "Offre de paiement échelonné n° {{index}}",
      "singleOfferTitle": "Offre de paiement échelonné",
      "apr": "T A P ",
      "remainingPayments": "Nombre de paiements restant : "
    },
    "perMonth": " /mois",
    "monthly": "Par mois",
    "zeroDown": "0 $ exigible aujourd'hui!",
    "payToday": "+ paiement aujourd'hui de : <downPayment />",
    "apr": "TAP",
    "interest": "Intérêts",
    "total": "Total",
    "months": " mois",
    "tooltip": "<div>Votre acompte de <strong><pureDownPayment /></strong> versé aujourd'hui sera suivi de <strong>{{numberOfPayments}} versements mensuels</strong> pour rembourser votre emprunt.</div>",
    "deferredPayment": {
      "text": "1er versement : janvier 2023",
      "mobile": {
        "firstInstallment": "1er versement :",
        "date": "janvier 2023"
      }
    },
    "zeroAPRLabel": "0% TAP",
    "lowestPaymentLabel": "Paiement mensuel le plus bas"
  },
  "inputs": {
    "card-info-name": {
      "isRequired": true,
      "label": "Nom du titulaire de la carte*",
      "validity": [
        ["required", "requis"],
        [
          "minLength1",
          "Nom du titulaire de la carte non valide",
          "ignore label"
        ]
      ]
    },
    "card-info-number": {
      "isRequired": true,
      "label": "Numéro de la carte*",
      "validity": [
        ["isValidCardNumberEn", "Numéro de carte non valide", "ignore label"]
      ]
    },
    "card-info-expiration": {
      "isRequired": true,
      "label": "Exp*",
      "mask": "99/99",
      "maxLength": 6,
      "format": "mmyyyy",
      "placeholder": "MM/YY",
      "srOnly": "M M Y Y",
      "validity": [["isValidCardExpiration", "Exp non valide", "ignore label"]]
    },
    "card-info-ccv": {
      "label": "CVV*",
      "isRequired": true,
      "tooltip": "<div>3 à 4 chiffres selon votre carte</div>",
      "validity": [["isValidCardCCV", "CVV non valide", "ignore label"]]
    },
    "billing-zip": {
      "label": "Code postal*",
      "isRequired": true,
      "mask": "X9X 9X9",
      "validity": [["isValidCardZip", "Code postal non valide", "ignore label"]]
    },
    "autopay": {
      "isRequired": true,
      "validity": []
    }
  },
  "autopay": {
    "label": "Activer AutoPay",
    "content": "<span>AutoPay est un moyen facile et pratique d'effectuer vos paiements mensuels.</span>",
    "modalContent": {
      "header": "Êtes-vous sûr?",
      "body": "AutoPay est un moyen simple et pratique d'effectuer vos paiements mensuels de prêt et vous évite de payer des frais d'intérêt supplémentaires pour paiements en retard.",
      "keep": "Garder AutoPay",
      "disable": "Désactiver AutoPay"
    }
  },
  "edit": "Modifier",
  "submit": "Continuer",
  "uplift": {
    "terms": "Modalités et conditions offertes par Uplift Canada Services ULC."
  },
  "flexpay": {
    "terms": "Modalités et conditions offertes par Uplift Canada Services ULC."
  },
  "splitOfferSelector": {
    "selectedOffer": {
      "dueToday": "À rendre aujourd'hui",
      "interestWithAPR": "Intérêt (<APRComponent/> TAP)",
      "selectedOffer": "Offre sélectionnée"
    },
    "changePaymentPlan": {
      "paymentPlan": "Plan de paiement",
      "change": "Changer"
    }
  }
}
